import { useCallback } from 'react'

import { useProjectT } from 'services/ProjectLabels'
import { useProjectContext, useProjectDispatch } from 'services/Store/Project/hooks'
import { getTestSubmitTrigger } from 'services/Store/Project/triggers'
import { focusMain } from 'utils/accessibility'

import BaseButtonElement from '../BaseButtonElement'
import type { ButtonElementType } from '../buttonTypes'
import { getButtonLabel } from '../helper'

interface IDefaultButtonElementProps extends React.ComponentProps<ButtonElementType> {
  children: React.ReactNode
}

const SubmitButtonElement: React.FC<IDefaultButtonElementProps> = ({
  element,
  mode,
  styles,
  block,
  font,
  children,
}) => {
  const dispatch = useProjectDispatch()
  //TODO: fix on 'useProjectT' after merging Project Settings MR
  const pt = useProjectT()
  const trigger = useProjectContext(getTestSubmitTrigger, { blockId: block?.uuid, pt })

  const onClick = useCallback(() => {
    if (!trigger.disabled) {
      dispatch(trigger.actionCreator())
    }
    const secondAction = trigger.secondActionCreator?.()
    if (secondAction) {
      dispatch(secondAction)
    }
    focusMain()
  }, [dispatch, trigger])

  const label = getButtonLabel(
    {
      'project/questionValidate': element.value.label,
      'project/setCourseNavigation': element.value.secondLabel,
      'project/questionReset': element.value.thirdLabel,
      'project/testEnd': element.value.fourthLabel,
      'project/courseEnd': element.value.fourthLabel,
      noop: element.value.label,
    },
    trigger.action,
  )

  if (trigger.hide) {
    return null
  }

  return (
    <BaseButtonElement
      action={element.value.action}
      disabled={trigger?.disabled}
      elementId={element.id}
      font={font}
      label={label}
      mode={mode}
      onClick={onClick}
      styles={styles}
      tooltip={trigger?.tooltip}
    >
      {children}
    </BaseButtonElement>
  )
}

export default SubmitButtonElement
